export const isNewDiffCheckerFeatureEnabled = () => {
    const isEnabled = process.env.REACT_APP_DIFF_CHECKER_FEATURE_ENABLED?.toString() === "true" || false;
  return isEnabled;
}

// Ask Allie is off unless REACT_APP_ASK_ALLIE_ENABLED is explicitly "true".
// Missing/unset env var (e.g. no CI wiring yet) safely defaults to disabled.
export const isAskAllieEnabled = () => {
  const isEnabled = process.env.REACT_APP_ASK_ALLIE_ENABLED?.toString() === "true" || false;
  return isEnabled;
}